import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
